'use strict';

require('@firebase/storage');

//# sourceMappingURL=index.cjs.js.map



//////////////////
// WEBPACK FOOTER
// ./~/firebase/storage/dist/index.cjs.js
// module id = 92
// module chunks = 0